import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Picken')
    .setChildren([
        MenuEntry.create()
            .setTitle('Dynamisch')
            .setRoute('pick_dynamic_overview')
            .setAdditionalRoutes([
                'pick_dynamic_pick_entry',
            ]),
        MenuEntry.create()
            .setTitle('Einboxen')
            .setRoute('box_in_box'),
        MenuEntry.create()
            .setTitle('Pickwagenübersicht')
            .setRoute('picking_cart_list')
            .setAdditionalRoutes([
                'picking_cart_create',
                'picking_cart_show',
            ]),
        MenuEntry.create()
            .setTitle('Boxübersicht')
            .setRoute('box_overview')
            .setAdditionalRoutes([
                'box_create',
                'box_show',
            ]),
        MenuEntry.create()
            .setTitle('Nicht gefundene Artikel')
            .setRoute('pick_not_found_list'),
        MenuEntry.create()
            .setTitle('Aktuell pickende Benutzer')
            .setRoute('pick_dynamic_user-list'),
        MenuEntry.create()
            .setTitle('Pickeinstellungen')
            .setChildren([
                MenuEntry.create()
                    .setRoute('settings_blocked_pick_queue_warehouse_groups'),
                MenuEntry.create()
                    .setRoute('express_pick_user'),
                MenuEntry.create()
                    .setRoute('settings_assigned_boxes_to_request_in_box'),
                MenuEntry.create()
                    .setRoute('settings_number_of_products_recommend_in_box'),
                MenuEntry.create()
                    .setRoute('settings_not_found_price'),
                MenuEntry.create()
                    .setRoute('settings_age_pick_queue_prioritize'),
                MenuEntry.create()
                    .setRoute('settings_single_ship_product'),
                MenuEntry.create()
                    .setRoute('setting_adjust_finish_date_weekday'),
                MenuEntry.create()
                    .setTitle('Anzahl freizuhaltender Boxen')
                    .setRoute('amount_one_bin_warehouse_reserved_boxes'),
                MenuEntry.create()
                    .setTitle('Produktgruppen vom Picken ausschließen')
                    .setRoute('settings_blocked_product_group_time_interval'),
            ]),
        MenuEntry.create()
            .setRoute('pick_dashboard'),
        MenuEntry.create()
            .setRoute('pick_docs'),
    ]);
